import React from "react";
import ReactDOM from "react-dom/client";
import AiIntegration from "./ai-integration";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AiIntegration />
  </React.StrictMode>,
);
